export default __webpack_public_path__ + "static/media/icon-close.0395484e.svg";